import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { EventCourse, Ticket } from 'services/graphqltypes';

// load course sessions tickets
const COURSE_SESSION_TICKETS = gql`
    query courseSessionsTickets($courseId: UUID!) {
    eventCourse(id: $courseId) {
      eventCoursesByCourseId(orderBy: START_TIME_ASC) {
        nodes {
          id
          name
          isEvent
          startTime
          locationName
          locationAddress
          locationCoordinates { x, y }
          locationGeojson
          tickets(orderBy: POSITION_ASC, filter: {isRedeem: {distinctFrom: true}, isSessionHelper: {distinctFrom: true}}) {
            nodes {
              id
              name
              eventCourseId
              priceAmount
              isPackage
              isWholeCourse
              eventCourse{
                name
                id
              }
              currencyByCurrencyCode {
                id
                code
              }
              isParticipant
              isRedeem
              hasName
              position
              description
              availableAmount
              remainingAmount
              ticketPackageContentsByPackageTicketId {
                nodes {
                  id
                  ticket {
                    id
                    eventCourseId
                  }
                }
              }
              bookingTickets {
              totalCount
              nodes {
                id
                booking {
                  id
                  code
                  orderState
                  totalPrice
                }
                amount
              }
            }
            }
          }
          sessionHelperTickets: tickets(orderBy: POSITION_ASC, filter: {isSessionHelper: {equalTo: true}}) {
            nodes {
              id
              isParticipant
              bookingTickets {
                nodes {
                  id
                  hasCheckedIn
                  participant {
                    id
                    name
                    username
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  `;

type useCourseSessionTicketsProps = {
    courseId: string;
}

const useCourseSessionTickets = ({ courseId } : useCourseSessionTicketsProps) =>{
  const { loading, data, error } = useQuery(COURSE_SESSION_TICKETS, {
    variables: {
      courseId: courseId
    },
    skip: !courseId,
  });

  const { courseSessionTickets, courseSessionHelperTickets, sessionTicketsData } = React.useMemo(() => {
    if (loading || error ||  !data?.eventCourse?.eventCoursesByCourseId?.nodes) {
      return  { courseSessionTickets: [], courseSessionHelperTickets: [], sessionTicketsData: [] };
    }

    const sessionTickets: Ticket[] = [];
    const sessionHelperTickets: Ticket[] = [];
        data?.eventCourse?.eventCoursesByCourseId?.nodes?.forEach((eventCourse: EventCourse)=>{
            eventCourse?.tickets?.nodes?.forEach((ticket: Ticket)=>{
              sessionTickets.push({ ...ticket });
            });
            (eventCourse as any)?.sessionHelperTickets?.nodes?.forEach((ticket: Ticket) => {
              sessionHelperTickets.push({ ...ticket });
            });
        });

        return  {
          courseSessionTickets: sessionTickets,
          courseSessionHelperTickets: sessionHelperTickets,
          sessionTicketsData: data?.eventCourse?.eventCoursesByCourseId?.nodes,
        };
  }, [data, error, loading]);

  return { loading, error, courseSessionTickets, courseSessionHelperTickets, sessionTicketsData };
};

export default useCourseSessionTickets;
